<fieldset>
  <legend>{{ 'CALENDAR.POPUP.TITLE.' + (isSinceCalendar ? 'START' : 'END') | translate:legendDate }} (UTC)</legend>
  <div class="container">
    <div>
      <aa-popup-navigation [isSinceCalendar]="isSinceCalendar">
      </aa-popup-navigation>
    </div>
    <div>
      <svg:svg class="background"
        [attr.width]="168"
        [attr.height]="144">
        <defs>
          <pattern id="dotted-pattern"
            x="1"
            y="1"
            width="3"
            height="3"
            patternUnits="userSpaceOnUse">
            <circle class="dotted"
              cx="1"
              cy="1"
              r="1" />
            </pattern>
            <pattern id="red-dotted-pattern"
              x="1"
              y="1"
              width="3"
              height="3"
              patternUnits="userSpaceOnUse">
              <circle class="red-dotted"
                cx="1"
                cy="1"
                r="1" />
              </pattern>
              <filter id="shadow">
                <feDropShadow dx="0.5"
                  dy="0.5"
                  stdDeviation="3" />
                </filter>
              </defs>
              @for (row of rows; track row) {
                <svg:svg class="calendar"
                  [attr.x]="0"
                  [attr.y]="cfg.cellHeight * row"
                  [attr.width]="cfg.calendarSize.width"
                  [attr.height]="cfg.cellHeight">
                  @for (col of cols; track col) {
                    <svg:svg class="day"
                      [attr.x]="cfg.cellWidth * col"
                      y="0"
                      [attr.width]="cfg.cellWidth"
                      [attr.height]="cfg.cellHeight"
                      (click)="onDayClick(visualDays[row][col])"
                      [ngClass]="{ currentMonth: visualDays[row][col].isInCurrentMonth, uncheckable: !visualDays[row][col].isCheckable, isInRange: visualDays[row][col].isInRange, today: visualDays[row][col].isToday, boundary: visualDays[row][col].isBoundary }">
                      <svg:rect y="0"
                        x="0"
                        [attr.width]="cfg.cellWidth"
                        [attr.height]="cfg.cellHeight"
                        [ngStyle]="{ fill: visualDays[row][col].isWeekend ? (visualDays[row][col].isCheckable ? 'url(#dotted-pattern)' : 'url(#red-dotted-pattern)') : '' }">
                        </svg:rect>
                        @if (visualDays[row][col].isToday || visualDays[row][col].isBoundary) {
                          <svg:circle r="10"
                            cx="12"
                            cy="12"
                            >
                            </svg:circle>
                          }
                          <svg:text x="50%"
                            y="50%"
                            dominant-baseline="central"
                            text-anchor="middle"
                            [ngClass]="{ today: visualDays[row][col].isToday }">
                            {{ visualDays[row][col].day }}
                            </svg:text>
                            </svg:svg>
                          }
                          </svg:svg>
                          }<svg:line class="border"
                          [attr.x1]="0"
                          [attr.y1]="0"
                          [attr.x2]="cfg.calendarSize.width"
                          [attr.y2]="0"></svg:line>
                          <svg:line class="border"
                            [attr.x1]="cfg.calendarSize.width"
                            [attr.y1]="0"
                            [attr.x2]="cfg.calendarSize.width"
                            [attr.y2]="cfg.calendarSize.height">
                            </svg:line>
                            <svg:line class="border"
                              [attr.x1]="cfg.calendarSize.width"
                              [attr.y1]="cfg.calendarSize.height"
                              [attr.x2]="0"
                              [attr.y2]="cfg.calendarSize.height">
                              </svg:line>
                              <svg:line class="border"
                                [attr.x1]="0"
                                [attr.y1]="cfg.calendarSize.height"
                                [attr.x2]="0"
                                [attr.y2]="0">
                                </svg:line>
                                </svg:svg>
                              </div>
                              <div>
                                <aa-hour-selector [isSinceCalendar]="isSinceCalendar">
                                </aa-hour-selector>
                              </div>
                            </div>
                          </fieldset>
